<template>
  <div class="colRight" v-loading.fullscreen.lock="fullscreenLoading">
    <div>
      <span
        class="nav-item ml-3"
        style="height: 40px; line-height: 40px; font-size: 15px"
        >平台名称:</span
      >
      <span
        class="nav-item ml-3"
        style="
          height: 40px;
          line-height: 40px;
          font-size: 18px;
          font-weight: bold;
        "
        >{{ platform_name }}</span
      >
      <div class="js_export_depart_progress"></div>
      <span
        class="nav-item ml-3"
        style="height: 40px; line-height: 40px; font-size: 15px"
        >项目名称:</span
      >
      <span
        class="nav-item ml-3"
        style="
          height: 40px;
          line-height: 40px;
          font-size: 18px;
          font-weight: bold;
        "
        >{{ project_name }}</span
      >
      <div class="js_export_depart_progress"></div>
      <div class="js_party_info" style="">
        <div
          class="ww_commonCntHead ww_commonCntHead_NoBorder card pt-3 pl-3 pr-3 pb-1">
          <div>
            <el-button
              type="primary"
              @click="toEdit(0, '')"
              class="button"
              plain
              size="medium"
              >新建建筑
            </el-button>
            <el-button
              type="primary"
              @click="$router.push({ path: 'edit_energy' })"
              class="button"
              plain
              size="medium"
              v-if="$check_auth('CONFIG_INFO_ENERGY')"
              >能耗模型管理
            </el-button>
            <el-button
              type="primary"
              @click="$router.push({ path: 'edit_branch' })"
              class="button"
              plain
              size="medium"
              >支路管理
            </el-button>
            <el-button
              type="primary"
              @click="$router.push({ path: 'edit_role' })"
              class="button"
              plain
              size="medium"
              >角色管理
            </el-button>
            <el-button
              type="success"
              @click="
                title = '导出建筑';
                outFormVisible = true;
                null_building_list();
              "
              >导出建筑类</el-button
            >
            <el-button
              type="success"
              @click="
                title = '导出能耗模型';
                outFormVisible = true;
                null_building_list();
              ">
              导出能耗模型
            </el-button>
            <el-button
              type="success"
              @click="
                title = '导出支路';
                outFormVisible = true;
                null_building_list();
              ">
              导出支路
            </el-button>
            <el-button
              type="success"
              @click="
                title = '导出设备';
                outFormVisible = true;
                null_building_list();
              ">
              导出设备
            </el-button>
            <el-button
              type="success"
              @click="
                title = '导出系统';
                outFormVisible = true;
                null_building_list();
              ">
              导出系统
            </el-button>
            <el-upload
              class="upload-demo"
              ref="all_upload1"
              :headers="{ 'Content-Type': 'multipart/form-data' }"
              :action="IBMS_API + 'NewEnergy/building/ImportProjectExcel'"
              :http-request="importFile"
              :show-file-list="false"
              :limit="1">
              <el-button type="danger">上传建筑类</el-button>
            </el-upload>
            <el-upload
              class="upload-demo"
              ref="all_upload5"
              :headers="{ 'Content-Type': 'multipart/form-data' }"
              :action="IBMS_API + 'NewEnergy/building/ParseBranchExcel'"
              :http-request="import_branch_File"
              :show-file-list="false"
              :limit="1">
              <el-button type="danger">上传支路</el-button>
            </el-upload>
            <el-upload
              class="upload-demo"
              ref="all_upload2"
              :headers="{ 'Content-Type': 'multipart/form-data' }"
              :action="IBMS_API + 'NewEnergy/building/ParseEquipExcel'"
              :http-request="import_equipmen_File"
              :show-file-list="false"
              :limit="1">
              <el-button type="danger">上传设备</el-button>
            </el-upload>
            <el-upload
              class="upload-demo"
              ref="all_upload4"
              :headers="{ 'Content-Type': 'multipart/form-data' }"
              :action="IBMS_API + 'NewEnergy/building/ParseEquipExcel'"
              :http-request="import_system_File"
              :show-file-list="false"
              :limit="1">
              <el-button type="danger">上传系统</el-button>
            </el-upload>
            <el-upload
              class="upload-demo"
              ref="all_upload3"
              :headers="{ 'Content-Type': 'multipart/form-data' }"
              :action="IBMS_API + 'NewEnergy/building/ParseEnergyModelExcel'"
              :http-request="import_consumption_File"
              :show-file-list="false"
              :limit="1">
              <el-button type="danger">上传能耗模型</el-button>
            </el-upload>
            <!--            <el-button type="danger" @click="query_upload_state" style="margin-left:15px">查询上传状态</el-button>-->
            <el-button
              type="primary"
              style="margin-left: 15px"
              @click="
                title = '下载建筑类模板';
                outFormVisible = true;
                null_building_list();
              "
              >下载建筑类模板
            </el-button>
            <el-button
              type="primary"
              @click="
                query_itemTree();
                outFormVisible = true;
                null_building_list();
                title = '下载设备模板';
              "
              :disabled="building_list.length === 0">
              下载设备模板
            </el-button>
            <el-button
              type="primary"
              @click="
                query_itemTree();
                outFormVisible = true;
                null_building_list();
                title = '下载系统模板';
              "
              :disabled="building_list.length === 0">
              下载系统模板
            </el-button>
            <el-button
              type="primary"
              @click="
                down_consumption_mb();
                null_building_list();
              "
              :disabled="building_list.length === 0"
              >下载能耗模型模板
            </el-button>
            <!--            <el-button type="info"-->
            <!--                       @click="show_BuildingSign = true;queryBuildingNameList();/*getRegionChange()*/">新建/查看-->
            <!--              建筑实体编码-->
            <!--            </el-button>-->
            <el-button type="warning" @click="inviteProjectCode = true"
              >邀请码
            </el-button>
            <el-button type="warning" @click="obj_dialog = true"
              >获取新对象id列表
            </el-button>
            <el-button
              type="warning"
              @click="
                centerDialogVisible_user = true;
                query_role_to_user();
              "
              >邀请用户
            </el-button>
            <el-dialog
              title="配置用户"
              :visible.sync="centerDialogVisible_user"
              tooltip-effect="dark"
              ref="multipleTable"
              width="30%"
              center>
              <div class="row mb-2">
                <label class="col-sm-4 text-lr lh40">选择角色：</label>
                <div class="col-sm-7 flex1 lh35">
                  <el-dropdown trigger="click" ref="Dropdown2">
                    <el-input
                      placeholder="请选择角色"
                      style="margin-bottom: 0"
                      @focus="query_role"
                      clearable
                      size="small"
                      v-model="roleName">
                    </el-input>
                    <el-dropdown-menu
                      slot="dropdown"
                      style="
                        min-width: 300px;
                        max-height: 400px;
                        overflow-y: scroll;
                      ">
                      <el-tree
                        :data="role_list"
                        @node-click="choice_role"
                        ref="tree"
                        class="filter-tree"
                        accordion
                        :props="defaultProps"></el-tree>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!--                <el-tree :data="role_list" :props="defaultProps" @node-click="handleNodeClick"></el-tree>-->
                </div>
              </div>
              <div class="row mb-2">
                <label class="col-sm-4 text-lr lh40">
                  <i
                    class="fa fa-asterisk text-danger font10 ml-1"
                    aria-hidden="true"></i>
                  选择用户 ：</label
                >
                <div class="col-sm-7">
                  <el-checkbox-group
                    v-model="link_user"
                    @change="get_user_data">
                    <el-checkbox
                      :label="value.id"
                      v-for="(value, index) in user_options"
                      :key="index"
                      >{{ value.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible_user = false"
                  >取 消</el-button
                >
                <el-button type="primary" @click="addusertoproject()"
                  >确定</el-button
                >
              </span>
            </el-dialog>
            <el-button @click="goBack" style="margin-left: 10px"
              >返回</el-button
            >
          </div>
        </div>
        <!--        邀请码-->
        <el-dialog
          title="邀请码"
          :visible.sync="inviteProjectCode"
          width="30%"
          center>
          <div>
            <div class="row mb-2">
              <label class="col-sm-4 text-lr lh40">选择角色：</label>
              <div class="col-sm-7 flex1 lh35">
                <el-dropdown trigger="click" ref="Dropdown2">
                  <el-input
                    placeholder="请选择角色"
                    style="margin-bottom: 0"
                    @focus="query_role"
                    clearable
                    size="small"
                    v-model="roleName">
                  </el-input>
                  <el-dropdown-menu
                    slot="dropdown"
                    style="
                      min-width: 300px;
                      max-height: 400px;
                      overflow-y: scroll;
                    ">
                    <el-tree
                      :data="role_list"
                      @node-click="choice_role"
                      ref="tree"
                      class="filter-tree"
                      accordion
                      :props="defaultProps"></el-tree>
                  </el-dropdown-menu>
                </el-dropdown>
                <!--                <el-tree :data="role_list" :props="defaultProps" @node-click="handleNodeClick"></el-tree>-->
              </div>
            </div>
            <div class="row mb-2">
              <label class="col-sm-4 text-lr lh40">邀请码：</label>
              <div class="col-sm-7 flex1 lh35">
                <el-input
                  v-model="inviteProject"
                  class="rt-input"
                  :disabled="true"></el-input>
              </div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="inviteProjectCode_type()"
              >生 成</el-button
            >
            <el-button
              @click="
                clearData();
                inviteProjectCode = false;
              "
              >关闭</el-button
            >
          </span>
        </el-dialog>
        <!--        对象id-->
        <el-dialog title="邀请码" :visible.sync="obj_dialog" width="30%" center>
          <div>
            <div class="row mb-2">
              <label class="col-sm-4 text-lr lh40">对象类编码：</label>
              <div class="col-sm-7 flex1 lh35">
                <el-select
                  @change="choice_obj_code"
                  v-model="obj_value"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :remote-method="search_category_code"
                  :loading="loading">
                  <el-option
                    v-for="item in obj_options"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>

                <!--                <el-input placeholder="请输入" style="margin-bottom: 0"-->
                <!--                          @blur="search_category_code"-->
                <!--                          clearable size="small" v-model="obj_code">-->
                <!--                </el-input>-->
              </div>
            </div>
            <div class="row mb-2">
              <label class="col-sm-4 text-lr lh40">生成id数量：</label>
              <div class="col-sm-7 flex1 lh35">
                <el-input-number
                  v-model="number"
                  :min="1"
                  label="请输入"
                  class="text item"></el-input-number>
              </div>
            </div>
            <div class="row mb-2">
              <label class="col-sm-4 text-lr lh40">id：</label>
              <div class="col-sm-5 flex1 lh35">
                <el-input
                  id="inputArea"
                  type="textarea"
                  :rows="4"
                  placeholder="请输入内容"
                  v-model="code_id_list">
                </el-input>
              </div>
              <div class="col-sm-2 flex1 lh35">
                <el-button type="text" @click="to_copy">复制</el-button>
              </div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="query_newobj()">生 成</el-button>
            <el-button
              @click="
                clearData();
                obj_dialog = false;
              "
              >关闭</el-button
            >
          </span>
        </el-dialog>
        <!-- 建筑实体编码       -->
        <el-dialog
          :close-on-click-modal="false"
          :show-close="false"
          top="4vh"
          title="实体编码"
          :visible.sync="show_BuildingSign"
          width="60%"
          center
          :before-close="show_BuildingSign_clear">
          <el-row :gutter="20">
            <el-col :span="12"
              ><!--   新建实体编码       -->
              <div
                style="
                  margin-top: 10px;
                  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12),
                    0 0 6px rgba(0, 0, 0, 0.04);
                  height: 470px;
                ">
                <div style="padding: 15px">
                  <h6 style="color: #909399; fontsize: 16px">新建实体编码</h6>
                  <span style="line-height: 40px">建筑名称:</span>
                  <span style="color: darkred; margin-left: 10px">{{
                    new_building_prompt
                  }}</span>
                  <el-input
                    v-model="newBuildingName"
                    placeholder="请输入建筑名称"></el-input>
                  <span style="line-height: 40px">建筑实体编码:</span>
                  <el-input
                    class="rt-input"
                    v-model="new_entity_code"
                    :disabled="true"></el-input>
                  <span style="line-height: 40px">项目实体编码:</span>
                  <el-input
                    class="rt-input"
                    v-model="new_project_code"
                    :disabled="true"></el-input>
                  <div>
                    <span>是否有建筑外部编码:</span>
                    <br />
                    <el-switch
                      active-text="是 "
                      inactive-text="否"
                      v-model="building_out_value"
                      active-color="#13ce66"
                      @change="change_building_out_value">
                    </el-switch>
                  </div>
                  <div class="hideSlow" :style="show_new_building_code">
                    <span id="touch">建筑外部编码:</span>
                    <el-input v-model="new_building_code"></el-input>
                  </div>
                  <el-button
                    type="success"
                    style="margin: 15px"
                    @click="newCreateProjectBuildingSign">
                    新 建
                  </el-button>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <!--   查看实体编码       -->
              <div
                style="
                  margin-top: 10px;
                  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12),
                    0 0 6px rgba(0, 0, 0, 0.04);
                  height: 470px;
                ">
                <div style="padding: 15px">
                  <h6 style="color: #909399; fontsize: 16px">查看实体编码</h6>
                  <div class="hideSlow" :style="show_buliding_name_list">
                    <span style="line-height: 40px">建筑名称:</span>
                    <el-select
                      style="margin-top: 15px"
                      @change="change_buliding_name_list()"
                      v-model="buildingName"
                      placeholder="请选择建筑">
                      <el-option
                        v-for="item in buliding_name_list"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                    <span style="color: darkred; margin-left: 10px">{{
                      building_prompt
                    }}</span>
                  </div>
                  <br />
                  <div class="hideSlow" :style="show_buliding_name_list">
                    <span :style="show_code">建筑实体编码:</span>
                    <el-input
                      class="rt-input"
                      v-model="entity_code"
                      :disabled="true"></el-input>
                  </div>
                  <span style="line-height: 40px">项目实体编码:</span>
                  <el-input
                    class="rt-input"
                    v-model="project_code"
                    :disabled="true"></el-input>
                  <div class="hideSlow" :style="show_buliding_name_list">
                    <span :style="show_code">建筑外部编码:</span>
                    <el-input
                      class="rt-input"
                      v-model="building_code"
                      :disabled="true"></el-input>
                  </div>
                  <br />
                  <el-switch
                    v-model="value1"
                    active-text="查询项目实体编码 "
                    inactive-text="查询建筑实体编码"
                    @change="SignFlag">
                  </el-switch>
                  <br />
                  <el-button type="danger" @click="deleteBuildingCode"
                    >删 除</el-button
                  >
                </div>
              </div>
            </el-col>
          </el-row>
          <span slot="footer" class="dialog-footer">
            <el-button @click="show_BuildingSign_clear">取 消</el-button>
          </span>
        </el-dialog>
        <!-- 导出设备、建筑 、系统      -->
        <el-dialog :title="title" :visible.sync="outFormVisible" width="30%">
          <el-form :model="formoutFormVisible" v-if="title === '导出设备'">
            <span style="margin: 0 10px"
              ><i
                class="fa fa-asterisk text-danger font10 ml-1"
                aria-hidden="true"></i
              >设备类型：</span
            >
            <el-dropdown trigger="click" ref="Dropdown2" class="item">
              <el-input
                placeholder="请选择设备类型"
                style="margin-bottom: 0"
                clearable
                size="small"
                v-model="equipTypeName"
                @focus="node_name = '设备'">
              </el-input>
              <el-dropdown-menu
                slot="dropdown"
                style="min-width: 300px; max-height: 400px; overflow-y: scroll">
                <el-tree
                  @node-click="handleNodeClick"
                  ref="typetree"
                  :props="props"
                  node-key="code"
                  :accordion="true"
                  :load="loadNode"
                  lazy>
                </el-tree>
              </el-dropdown-menu>
            </el-dropdown>
            <div style="margin-top: 15px">
              <span style="margin: 0 10px"
                >导出类型：
                <el-radio-group v-model="radio" @change="choiceType">
                  <el-radio :label="0">按项目导出</el-radio>
                  <el-radio :label="1">按建筑导出</el-radio>
                </el-radio-group>
              </span>
              <div style="margin: 10px 10px" v-if="radio === 1">
                建筑：
                <el-select
                  v-model="building_name"
                  placeholder="请选择"
                  @change="choiceBuild">
                  <el-option
                    v-for="item in building_list"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-form>
          <el-form :model="formoutFormVisible" v-if="title === '导出系统'">
            <span style="margin: 0 10px"
              ><i
                class="fa fa-asterisk text-danger font10 ml-1"
                aria-hidden="true"></i
              >系统类型：</span
            >
            <el-dropdown trigger="click" ref="Dropdown2" class="item">
              <el-input
                placeholder="请选择系统类型"
                style="margin-bottom: 0"
                clearable
                size="small"
                v-model="sysTypeName"
                @focus="node_name = '系统'">
              </el-input>
              <el-dropdown-menu
                slot="dropdown"
                style="min-width: 300px; max-height: 400px; overflow-y: scroll">
                <el-tree
                  @check-change="handleNodeClick3"
                  ref="typetree"
                  :props="props"
                  node-key="code"
                  :accordion="true"
                  :load="loadNode"
                  show-checkbox
                  lazy>
                </el-tree>
              </el-dropdown-menu>
            </el-dropdown>
            <div style="margin-top: 15px">
              <span style="margin: 0 10px"
                >导出类型：
                <el-radio-group v-model="radio" @change="choiceType">
                  <el-radio :label="0">按项目导出</el-radio>
                  <el-radio :label="1">按建筑导出</el-radio>
                </el-radio-group>
              </span>
              <div style="margin: 10px 10px" v-if="radio === 1">
                建筑：
                <el-select
                  v-model="building_name"
                  placeholder="请选择"
                  @change="choiceBuild">
                  <el-option
                    v-for="item in building_list"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-form>
          <el-form :model="formoutFormVisible" v-if="title === '导出建筑'">
            <span style="margin: 0 10px"
              >导出类型：
              <el-radio-group v-model="radio" @change="choiceType">
                <el-radio :label="0">按项目导出</el-radio>
                <el-radio :label="1">按建筑导出</el-radio>
              </el-radio-group>
            </span>
            <div style="margin: 10px 10px" v-if="radio === 1">
              <i
                class="fa fa-asterisk text-danger font10 ml-1"
                aria-hidden="true"></i
              >建筑：
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >全选
              </el-checkbox>
              <div style="margin: 15px 0"></div>
              <el-checkbox-group
                v-model="building_names"
                @change="handleCheckedCitiesChange">
                <el-checkbox
                  v-for="item in building_list"
                  :label="item"
                  true-label
                  :key="item.id">
                  {{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div style="margin: 10px 10px">
              <i
                class="fa fa-asterisk text-danger font10 ml-1"
                aria-hidden="true"></i
              >分类：
              <el-select v-model="ex_type" placeholder="请选择">
                <el-option
                  v-for="item in ex_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label">
                </el-option>
              </el-select>
            </div>
          </el-form>
          <el-form :model="formoutFormVisible" v-if="title === '导出支路'">
            <div style="margin-top: 15px">
              <div style="margin: 10px 10px">
                建筑：
                <el-select
                  v-model="building_name"
                  placeholder="请选择"
                  @change="choiceBuild">
                  <el-option
                    v-for="item in building_list"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-form>
          <el-form
            :model="formoutFormVisible"
            v-if="
              title === '导出能耗模型' ||
              title === '下载能耗模型模板' ||
              title === '处理对象' ||
              title === '处理系统' ||
              title === '处理空间竖井楼层' ||
              title === '处理设备'
            ">
            <div style="margin: 10px 10px">
              <i
                class="fa fa-asterisk text-danger font10 ml-1"
                aria-hidden="true"></i
              >建筑：
              <el-select
                v-model="building_name"
                placeholder="请选择"
                @change="choiceBuild">
                <el-option
                  v-for="item in building_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div style="margin: 10px 10px" v-if="title === '处理空间竖井楼层'">
              <i
                class="fa fa-asterisk text-danger font10 ml-1"
                aria-hidden="true"></i
              >分类：
              <el-select
                v-model="handleModelList_name"
                placeholder="请选择"
                @change="choiceHandleModelList"
                v-if="title === '处理空间竖井楼层'">
                <el-option
                  v-for="item in handleModelList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </div>
          </el-form>
          <el-form
            :model="formoutFormVisible"
            v-if="title === '下载建筑类模板'">
            <div style="margin: 10px 10px">
              <i
                class="fa fa-asterisk text-danger font10 ml-1"
                aria-hidden="true"></i
              >分类：
              <el-select v-model="ex_type" placeholder="请选择">
                <el-option
                  v-for="item in ex_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label">
                </el-option>
              </el-select>
            </div>
          </el-form>
          <el-form :model="formoutFormVisible" v-if="title === '下载设备模板'">
            <span style="margin: 0 10px"
              ><i
                class="fa fa-asterisk text-danger font10 ml-1"
                aria-hidden="true"></i
              >设备类型：</span
            >
            <el-dropdown trigger="click" ref="Dropdown2" class="item">
              <el-input
                placeholder="请选择设备类型"
                style="margin-bottom: 0"
                clearable
                size="small"
                v-model="equipTypeName"
                @focus="node_name = '设备'">
              </el-input>
              <el-dropdown-menu
                slot="dropdown"
                style="min-width: 300px; max-height: 400px; overflow-y: scroll">
                <el-tree
                  @node-click="handleNodeClick"
                  ref="typetree"
                  :props="props"
                  node-key="code"
                  :accordion="true"
                  :load="loadNode"
                  lazy>
                </el-tree>
              </el-dropdown-menu>
            </el-dropdown>
            <!--            <el-dropdown trigger="click" ref="Dropdown" style="width: 70%">-->
            <!--              <el-input placeholder="请选择设备类型" style="margin-bottom: 0"-->
            <!--                        clearable size="small" v-model="equipTypeName">-->
            <!--              </el-input>-->
            <!--              <el-dropdown-menu slot="dropdown"-->
            <!--                                style="min-width: 300px;max-height: 400px;overflow-y: scroll">-->
            <!--                <el-tree :data="equipTypeTree" @node-click="handleNodeClick"-->
            <!--                         ref="tree" class="filter-tree" accordion-->
            <!--                ></el-tree>-->
            <!--              </el-dropdown-menu>-->
            <!--            </el-dropdown>-->
          </el-form>
          <el-form :model="formoutFormVisible" v-if="title === '下载系统模板'">
            <span style="margin: 0 10px"
              ><i
                class="fa fa-asterisk text-danger font10 ml-1"
                aria-hidden="true"></i
              >系统类型：</span
            >
            <el-dropdown trigger="click" ref="Dropdown2" class="item">
              <el-input
                placeholder="请选择设备类型"
                style="margin-bottom: 0"
                clearable
                size="small"
                v-model="sysTypeName"
                @focus="node_name = '系统'">
              </el-input>
              <el-dropdown-menu
                slot="dropdown"
                style="min-width: 300px; max-height: 400px; overflow-y: scroll">
                <el-tree
                  @check-change="handleNodeClick3"
                  ref="typetree"
                  :props="props"
                  node-key="code"
                  :accordion="true"
                  :load="loadNode"
                  show-checkbox
                  lazy>
                </el-tree>
              </el-dropdown-menu>
            </el-dropdown>
            <!--            <el-dropdown trigger="click" ref="Dropdown" style="width: 70%">-->
            <!--              <el-input placeholder="请选择设备类型" style="margin-bottom: 0"-->
            <!--                        clearable size="small" v-model="equipTypeName">-->
            <!--              </el-input>-->
            <!--              <el-dropdown-menu slot="dropdown"-->
            <!--                                style="min-width: 300px;max-height: 400px;overflow-y: scroll">-->
            <!--                <el-tree :data="equipTypeTree" @node-click="handleNodeClick"-->
            <!--                         ref="tree" class="filter-tree" accordion-->
            <!--                ></el-tree>-->
            <!--              </el-dropdown-menu>-->
            <!--            </el-dropdown>-->
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              @click="
                outFormVisible = false;
                clearData();
              "
              >取 消</el-button
            >
            <el-button type="primary" @click="toDo">确 定</el-button>
          </div>
        </el-dialog>
        <div class="js_has_member container-fluid">
          <!-- 右侧主体表格-->
          <div class="mt-3">
            <vxe-table
              v-loading="loading"
              border
              empty-text="暂无数据"
              resizable
              row-key
              show-overflow
              highlight-hover-row
              ref="xTable"
              max-height="760"
              :data="building_list">
              <vxe-table-column
                type="seq"
                width="60"
                title="序号"></vxe-table-column>
              <vxe-table-column field="id" title="建筑id"></vxe-table-column>
              <vxe-table-column
                field="name"
                title="建筑名称"></vxe-table-column>
              <!--              <vxe-table-column field="building_type" title="建筑类型"></vxe-table-column>-->
              <!--              <vxe-table-column field="area" title="建筑面积"></vxe-table-column>-->
              <!--              <vxe-table-column field="created_time" title="创建时间"></vxe-table-column>-->
              <vxe-table-column title="操作" width="220" show-overflow>
                <template #default="{ row }">
                  <span style="color: #0e8bde" @click="toEdit(1, row)"
                    >编辑</span
                  >
                  <span
                    style="color: #f41212; margin-left: 8px"
                    @click="is_todo(row)"
                    >删除</span
                  >
                </template>
              </vxe-table-column>
            </vxe-table>
            <el-pagination
              :current-page="page"
              :page-size="pageSize"
              :page-sizes="[10, 30, 50, 100]"
              :total="total"
              align="center"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              style="margin-bottom: 10px">
            </el-pagination>
          </div>
        </div>
      </div>
      <!--        新建权限弹窗-->
      <el-dialog
        title="新建权限"
        :visible.sync="dialogVisible"
        v-if="dialogVisible"
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="30%"
        :destroy-on-close="true">
        <label class="col-sm-4 text-lr lh40">
          <i
            class="fa fa-asterisk text-danger font10 ml-1"
            aria-hidden="true"></i
          >所属功能模块：</label
        >
        <el-select v-model="value" placeholder="请选择" @focus="get_func_list">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <div v-for="(val, index) in auth_attr_list" :key="index">
          <div>
            <inputBox
              v-if="val.c_data_type === 'Str'"
              :Data="{ obj: 'new_auth', data: val, attr: '' }"></inputBox>
          </div>
          <div>
            <radio
              v-if="val.c_data_type === 'Enum'"
              :Data="{ obj: 'new_auth', data: val, attr: '' }"></radio>
          </div>
          <div>
            <txt
              v-if="val.c_data_type === 'Txt'"
              :Data="{ obj: 'new_auth', data: val, attr: '' }"></txt>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="(dialogVisible = false), (auth_attr_list = [])"
            >取 消</el-button
          >
          <el-button type="primary" @click="add_auth">保 存</el-button>
        </span>
      </el-dialog>
      <!--        上传状态弹窗-->
      <el-dialog
        title="上传状态"
        :visible.sync="upload_dialog"
        v-if="upload_dialog"
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="30%"
        :destroy-on-close="true">
        <el-table
          :data="upload_state_list"
          border
          height="550px"
          style="width: 100%">
          <el-table-column prop="id" label="ID"> </el-table-column>
          <el-table-column prop="state" label="状态"> </el-table-column>
          <el-table-column prop="last_upload_time" label="最后上传时间">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="{ row }">
              <el-button
                type="danger"
                size="small"
                @click="down_error_flie(row)"
                :disabled="row.state !== '上传异常'"
                >下载异常文件
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="upload_dialog = false">关 闭</el-button>
          <el-button @click="query_upload_state" type="primary"
            >刷 新</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import inputBox from '@/components/IBMS/function/general_func_group/input';
import radio from '@/components/IBMS/function/general_func_group/radio';
import txt from '@/components/IBMS/function/general_func_group/txt';

export default {
  name: 'config_index',
  components: { inputBox, radio, txt },
  data() {
    return {
      multipleTable: [],
      user_list: [],
      centerDialogVisible_user: false,
      input_upload_model: '',
      centerDialogVisible: false,
      message_number: 0,
      fullscreenLoading: false,
      buildingName_type: [],
      show_buliding_name_list: {
        display: 'block',
      },
      show_code: {
        lineHeight: '40px',
        display: 'block',
      },
      building_code: '',
      new_building_code: '',
      show_new_building_code: {
        display: 'none',
        marginTop: '20px',
      },
      building_out_value: false,
      pr_name: '',
      city_name: '',
      dis_name: '',
      loadingtree: false,
      defaultProps: {
        children: 'children',
        label: 'name',
        id: 'id',
      },

      regionData: [],
      areaInfo: [],
      regionName: '',
      buliding_name_list: [],
      new_building_prompt: '',
      newBuildingName: '',
      building_prompt: '',
      value1: false,
      flag_type: 0,
      inviteProject: '',
      inviteProjectCode: false,
      new_entity_code: '',
      new_project_code: '',
      entity_code: '',
      project_code: '',
      buildingName: '',
      show_BuildingSign: false,
      checkAll: false,
      isIndeterminate: true,
      dialogFormVisible: false,
      outFormVisible: false,
      platformid: this.$store.state.platform_Id,
      options: [],
      user_options: [],
      value: null,
      auth_attr_list: [],
      dialogVisible: false,
      loading: false,
      project_list: [],
      user_id: this.$store.state.user_id,
      project_id: this.$store.state.project_id,
      project_codes: this.$store.state.project_code,
      project_name: this.$store.state.project_name,
      platform_name: this.$store.state.platform_name,
      showFlag: false,
      fresh: false,
      formLabelWidth: '100px',
      formdialogFormVisible: {
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      formoutFormVisible: {
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      page: 1,
      pageSize: 10,
      total: 0,
      building_ids: [],
      building_id: '',
      building_names: [],
      building_list: [],
      itemTreeData: [],
      equipTypeName: '',
      sysTypeName: '',
      equipTypeTree: [],
      ex_build_dia: false, //导出建筑弹框
      title: '导出设备',
      radio: 0,
      ex_options: [
        {
          value: '1',
          label: '建筑',
        },
        {
          value: '2',
          label: '楼层',
        },
        {
          value: '3',
          label: '竖井',
        },
        {
          value: '4',
          label: '物业分区',
        },
      ],
      building_name: '',
      ex_type: '建筑',
      category_code: '',
      upload_id: '',
      upload_dialog: false,
      upload_state_list: [],
      multipleSelection: [],
      statusDescription: '',
      show_statusDescription: false,
      showcenterDialogVisible: false,
      showToMysql: false,
      centerDialogVisible_addhtml: false,
      html: '',
      type: '',
      title_code: '',
      centerDialogVisible_showhtml: false,
      html_list: [],
      handleModelList_name: '',
      handleModelList: [
        {
          name: '楼层',
          id: '楼层',
        },
        {
          name: '竖井',
          id: '竖井',
        },
        {
          name: '物业分区',
          id: '物业分区',
        },
      ],
      node_name: '',
      props: {
        label: 'name',
        id: 'code',
        children: 'children',
      },
      object_code: '',
      roleName: '',
      role_list: [],
      role_id: '',
      obj_dialog: false,
      obj_code: '',
      number: 1,
      code_id_list: [],
      link_user: [],
      systemId_list: [],
      temp_list: [],
      obj_options: [],
      obj_value: '',
    };
  },
  watch: {},
  mounted() {
    console.log(this.code_id_list, '33');
    this.get_building_list();
  },
  methods: {
    choice_obj_code(data) {
      console.log(data.split('-'), 'er3');
      this.obj_code = data.split('-')[1];
    },
    //模糊搜索id列表
    search_category_code(data) {
      this.obj_options = [];
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'Common/SearchCategoryCode',
        params: {
          name: data,
          page: 1,
          size: 100,
        },
      }).then((response) => {
        console.log(response.data);
        for (let i in response.data.content.data) {
          this.obj_options.push(
            response.data.content.data[i].name +
              '-' +
              response.data.content.data[i].code
          );
        }
        // this.obj_options = response.data.data
      });
    },
    handleNodeClick3(data, f) {
      console.log(data, f, '233');
      if (f === true) {
        this.systemId_list.push(data.code);
        this.temp_list.push(data.name);
      } else {
        for (let i in this.systemId_list) {
          if (this.systemId_list[i] === data.code) {
            this.systemId_list.splice(i, 1);
            this.temp_list.splice(i, 1);
          }
        }
      }
      this.sysTypeName = this.temp_list.toString();
    },
    //复制
    to_copy() {
      let that = this;
      var input = document.getElementById('inputArea');
      input.value = that.code_id_list; // 要复制的文本框的内容
      input.select(); // 选中文本
      document.execCommand('copy');
      alert('复制成功');
    },
    //邀请用户
    addusertoproject() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/DeliveryPlatform/AddUserToProject',
        data: {
          data: {
            user_id_list: this.link_user,
            role_id: this.role_id,
          },
        },
      }).then((response) => {
        console.log(response.data);
        if (response.data.result === 200) {
          this.$message({
            message: '邀请成功',
            type: 'success',
          });
          this.centerDialogVisible_user = false;
        } else if (response.data.result === 1010) {
          this.$message({
            message: '用户已绑定项目',
            type: 'error',
          });
        }
      });
    },
    get_user_data(data) {
      console.log(data);
    },
    //查询角色下级关联所有用户(面板用户列表)
    query_role_to_user() {
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectTree',
        params: {
          object_code: '10',
          need_user_tree: '1',
        },
      }).then((response) => {
        // var arry=[{'id':'','name':'未分级用户','children':response.data.content[1].user_list}]
        // var list = this.r_user(response.data.content[0])
        this.user_options = response.data.content[0].user_list;
      });
    },
    //获取新对象id列表
    query_newobj() {
      // this.obj_dialog = true
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/DeliveryPlatform/GetNewObjectIdList',
        params: {
          num: this.number,
          object_code: this.obj_code,
        },
      }).then((response) => {
        console.log(response.data);
        this.code_id_list = response.data.content.id_list;
      });
    },

    //选择角色
    choice_role(data) {
      console.log(data);
      this.roleName = data.name;
      this.role_id = data.id;
    },
    //查询角色
    query_role() {
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectTree',
        params: {
          project_id: this.project_id,
          object_code: '4401',
        },
      }).then((response) => {
        console.log(response.data);
        this.role_list = response.data.content;
      });
    },
    //设备，系统懒加载
    loadNode(node, resolve) {
      console.log(node, this.node_name, '45');
      if (node.level === 0) {
        this.query_itemTree(resolve);
      }
      console.log(node.isLeaf, '234');
      if (this.node_name === '设备' && node.level === 4) {
        return resolve([]);
      }
      if (node.level >= 1 && node.isLeaf === false) {
        this.query_nextObjs(node, resolve);
      }
    },
    //设备类型下拉：查询设备类型树
    query_itemTree(resolve) {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/QueryTypeTree',
        data: {
          version: '1.1',
          data: {
            code: '',
            type: '设备',
          },
        },
      }).then((response) => {
        this.equipTypeTree = response.data.content.list;
        return resolve(this.equipTypeTree);
      });
    },
    //查询下一级对象类
    query_nextObjs(node, resolve) {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/QueryTypeTree',
        data: {
          version: '1.1',
          data: {
            type: this.node_name,
            code: String(node.data.code),
          },
        },
      }).then((response) => {
        if (response.data.result === 200) {
          return resolve(response.data.content.list);
        } else {
          return resolve([]);
        }
      });
    },
    //查询建筑列表
    get_building_list() {
      this.loading = true;
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
          object_code: '12',
          project: this.project_id,
          page: this.page,
          size: this.pageSize,
        },
      }).then((response) => {
        this.building_list = response.data.content.data;
        if (this.building_list.length !== 0) {
          this.message_number = 1;
        }
        this.total = response.data.content.totalElements;
        this.loading = false;
        this.null_building_list();
      });
    },
    //邀请用户
    handleSelectionChange(row) {
      this.multipleSelection = [];
      for (let selectedItem of row) {
        this.multipleSelection.push(selectedItem.id);
      }
      this.isDelBatchMerchantBtn = !this.isDelBatchMerchantBtn;
      console.log(this.multipleSelection, 'handleSelectionChange');
    },
    invitationUser() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'global/InvitationUser',
        data: {
          version: 'V1.1',
          timestamp: '0',
          data: {
            user_id_list: this.multipleSelection,
            project_id: this.project_id,
            platform_id: this.platformid,
          },
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            message: '邀请成功',
            type: 'success',
          });
          this.centerDialogVisible_user = false;
        } else {
          this.$message({
            message: '邀请失败',
            type: 'error',
          });
        }
      });
    },
    //查询所有用户
    queryAllUser() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'global/QueryAllUser',
        data: {
          version: 'V1.1',
          timestamp: '0',
          data: {},
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.user_list = response.data.content.user_list;
        }
      });
    },
    //处理设备对象
    exportBIMEquipmentObject() {
      this.fullscreenLoading = true;
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'NewEnergy/building/ExportBIMEquipmentObject',
        data: {
          version: 'V1.1',
          timestamp: '0',
          data: {
            project_id: this.project_id,
            platform_id: this.platformid,
            building_id: this.building_id,
          },
        },
        responseType: 'blob',
      }).then((response) => {
        if (!response) {
          return;
        }
        this.fullscreenLoading = false;
        const content = response.data;
        const blob = new Blob([content], { type: 'application/zip' });
        console.log(response.headers, 'response.headers');
        let name = response.headers['content-length'];
        const fileName = name + '.zip';
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a');
          elink.download = decodeURI(fileName);
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
        this.outFormVisible = false;
        this.$message({
          type: 'success',
          message: '下载成功!',
        });
        this.clearData();
      });
    },
    //处理空间竖井楼层对象
    handleMode() {
      this.fullscreenLoading = true;
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/global/CONFIG/NewProject/HandleModel',
        data: {
          version: 'V1.1',
          timestamp: '0',
          data: {
            project_id: this.project_id,
            platform_id: this.platformid,
            building_id: this.building_id,
            name: this.handleModelList_name,
          },
        },
        responseType: 'blob',
      }).then((response) => {
        if (!response) {
          return;
        }
        this.fullscreenLoading = false;
        let blob = new Blob([response.data], { type: '' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        console.log(response.headers, 'response.headers123456');
        let name = response.headers['content-disposition'].split('=')[1];
        link.download = decodeURI(name);
        document.body.appendChild(link);
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', false, false);
        link.dispatchEvent(evt);
        document.body.removeChild(link);
        this.outFormVisible = false;
        this.$message({
          type: 'success',
          message: '下载成功!',
        });
        this.clearData();
      });
    },
    //处理系统对象
    handleSystem() {
      this.fullscreenLoading = true;
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/global/CONFIG/NewProject/HandleSystem',
        data: {
          version: 'V1.1',
          timestamp: '0',
          data: {
            project_id: this.project_id,
            platform_id: this.platformid,
            building_id: this.building_id,
          },
        },
        responseType: 'blob',
      }).then((response) => {
        if (!response) {
          return;
        }
        this.fullscreenLoading = false;
        let blob = new Blob([response.data], { type: '' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        let name = response.headers['content-disposition'].split('=')[1];
        link.download = decodeURI(name);
        document.body.appendChild(link);
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', false, false);
        link.dispatchEvent(evt);
        document.body.removeChild(link);
        this.outFormVisible = false;
        this.$message({
          type: 'success',
          message: '下载成功!',
        });
        this.clearData();
      });
    },
    //处理管线对象，结构
    handleStructure() {
      this.fullscreenLoading = true;
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/global/CONFIG/NewProject/HandleStructure',
        data: {
          version: 'V1.1',
          timestamp: '0',
          data: {
            project_id: this.project_id,
            platform_id: this.platformid,
            building_id: this.building_id,
          },
        },
        responseType: 'blob',
      }).then((response) => {
        if (!response) {
          return;
        }
        this.fullscreenLoading = false;
        let blob = new Blob([response.data], { type: '' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        let name = response.headers['content-disposition'].split('=')[1];
        link.download = decodeURI(name);
        document.body.appendChild(link);
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', false, false);
        link.dispatchEvent(evt);
        document.body.removeChild(link);
        this.outFormVisible = false;
        this.$message({
          type: 'success',
          message: '下载成功!',
        });
        this.clearData();
      });
    },
    //切换空间竖井楼层
    choiceHandleModelList(row) {
      this.handleModelList_name = row;
    },
    //查看标签
    queryTitleHtml() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'NewEnergy/building/title_html/get_all',
        data: {
          version: 'V1.1',
          timestamp: '0',
          data: {
            platform_id: this.platformid,
          },
        },
      }).then((response) => {
        this.html_list = response.data.content.html_list;
      });
    },
    //新建标签
    createdTitleHtml() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'NewEnergy/building/title_html/create_one',
        data: {
          version: 'V1.1',
          timestamp: '0',
          data: {
            platform_id: this.platformid,
            title_code: this.title_code,
            type: this.type,
            html: this.html,
          },
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            type: 'success',
            message: '添加成功!',
          });
          this.html = '';
          this.type = '';
          this.title_code = '';
          this.queryTitleHtml();
        }
      });
    },
    //同步模型
    uploadToMysql() {
      this.$axios({
        method: 'post',
        url: 'http://192.168.10.56:9000/api/NewEnergy/building/UploadToMysql',
        data: {
          version: 'V1.1',
          timestamp: '0',
          data: {
            building_id: this.building_id,
            platform_id: this.platformid,
          },
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.codeMsg = response.data.content.codeMsg;
          this.$message({
            type: 'success',
            message: this.codeMsg,
          });
        } else {
          this.$message({
            type: 'error',
            message: '同步失败!',
          });
        }
        this.showToMysql = false;
      });
    },
    //查看上传模型状态
    view_upload_model() {
      let postData = new FormData();
      postData.append('building_id', this.building_id);
      postData.append('platform_id', this.platformid);
      this.$axios({
        method: 'post',
        url: 'http://192.168.10.56:9000/api/NewEnergy/building/GetUploadStatus',
        data: postData,
      }).then((response) => {
        if (response.data.result === 200) {
          this.statusDescription =
            response.data.content.datas[0].statusDescription;
        } else {
          this.statusDescription = '该建筑模型不存在';
        }
        this.show_statusDescription = true;
      });
    },
    //上传模型
    upload_model(content) {
      this.fullscreenLoading = true;
      let postData = new FormData();
      postData.append('file', content.file);
      postData.append('platform_id', this.platformid);
      postData.append('building_id', this.input_upload_model);
      this.$axios({
        method: 'post',
        url: 'http://192.168.10.56:9000/api/NewEnergy/building/UploadModel',
        data: postData,
        responseType: 'blob',
      }).then((response) => {
        let blob = new Blob([response.data], { type: '' });
        let reader = new FileReader();
        this.fullscreenLoading = false;
        reader.addEventListener('loadend', () => {
          try {
            let res = JSON.parse(reader.result);
            if (res.result === 200) {
              this.$message({
                type: 'success',
                message: '上传成功!',
              });
              this.centerDialogVisible = false;
            } else {
              this.$message({
                type: 'error',
                message: '上传失败!',
              });
              this.centerDialogVisible = false;
            }
          } catch (err) {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            let name = response.headers['content-disposition'].split('=')[1];
            link.download = decodeURI(name);
            document.body.appendChild(link);
            var evt = document.createEvent('MouseEvents');
            evt.initEvent('click', false, false);
            link.dispatchEvent(evt);
            document.body.removeChild(link);
          }
        });
        reader.readAsText(blob, 'utf-8');
        this.$refs.all_upload4.clearFiles();
      });
    },
    clearData() {
      this.radio = 0;
      this.building_ids = [];
      this.checkAll = [];
      this.building_names = [];
      this.equipTypeName = '';
      this.building_id = '';
      this.role_id = '';
      this.inviteProject = '';
      this.roleName = '';
      this.code_id_list = [];
      this.obj_code = '';
      this.number = '';
      this.obj_value = '';
    },
    choiceType(data) {
      console.log(data, '456');
      // if(data==='0'){
      this.buildingName_type = '';
      this.building_ids = [];
      this.checkAll = [];
      this.building_names = [];
      this.ex_type = '建筑';
      // }
      // else {
      //     this.project_id=''
      // }
    },
    change_building_out_value() {
      if (this.building_out_value === true) {
        this.show_new_building_code.display = 'block';
      } else {
        this.new_building_code = '';
        this.show_new_building_code.display = 'none';
      }
    },
    // 获取省市区数据
    getRegionChange() {
      this.loadingtree = true;
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'Common/region',
        data: {},
      }).then((response) => {
        this.regionData = response.data.content;
        this.loadingtree = false;
      });
    },
    // 树节点的点击事件
    handletreeNodeClick(a, Node) {
      if (a.sonList.length === 0) {
        this.regionName =
          Node.parent.parent.data.name +
          '-' +
          Node.parent.data.name +
          '-' +
          Node.data.name;
        this.pr_name = Node.parent.parent.data.name;
        this.city_name = Node.parent.data.name;
        this.dis_name = Node.data.name;
        this.areaInfo = [];
        this.$refs.dropdown.hide();
      }
    },
    change_buliding_name_list() {
      this.entity_code = '';
      this.project_code = '';
      this.createProjectBuildingSign();
    },
    SignFlag() {
      if (this.value1 === false) {
        this.flag_type = 0;
        this.show_buliding_name_list.display = 'block';
        this.show_code.display = 'block';
      } else if (this.value1 === true) {
        this.flag_type = 1;
        this.entity_code = '';
        this.building_code = '';
        this.buildingName = '';
        this.show_buliding_name_list.display = 'none';
        this.show_code.display = 'none';
        this.createProjectBuildingSign();
      }
    },
    //创建邀请码
    inviteProjectCode_type() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Config/InviteProjectCode',
        data: {
          version: 'V1.1',
          timestamp: '0',
          data: {
            project_id: this.project_id,
            role_id: this.role_id,
          },
        },
      }).then((response) => {
        this.inviteProject = response.data.content.project_code;
        // this.inviteProjectCode = false
      });
    },
    choiceBuild(value) {
      this.building_id = value;
    },
    toDo() {
      if (this.title === '下载建筑类模板') {
        this.down_build_mb();
      } else if (this.title === '下载设备模板') {
        this.down_equipment_mb();
      } else if (this.title === '下载系统模板') {
        this.down_system_mb();
      } else if (this.title === '导出建筑') {
        this.export_build_mb();
      } else if (this.title === '导出设备') {
        this.export_equipment_mb();
      } else if (this.title === '导出系统') {
        this.export_equipment_xt();
      } else if (this.title === '导出能耗模型') {
        this.export_consumption_mb();
      } else if (this.title === '下载能耗模型模板') {
        this.down_consumption_mb();
      } else if (this.title === '处理对象') {
        this.handleStructure();
      } else if (this.title === '处理系统') {
        this.handleSystem();
      } else if (this.title === '处理空间竖井楼层') {
        this.handleMode();
      } else if (this.title === '处理设备') {
        this.exportBIMEquipmentObject();
      } else if (this.title === '导出支路') {
        this.export_branch();
      }
      this.clearData();
    },
    //导出系统
    export_equipment_xt() {
      this.fullscreenLoading = true;
      var id = this.project_id;
      if (this.radio === 0) {
        this.building_id = '';
      } else {
        id = null;
      }
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/export_and_import/system/export',
        data: {
          version: '1.1',
          data: {
            code_list: this.systemId_list,
            project_id: id,
            building_id: this.building_id,
          },
        },
        responseType: 'blob',
      }).then((response) => {
        console.log(response);
        if (!response) {
          return;
        }
        this.fullscreenLoading = false;
        let blob = new Blob([response.data], { type: '' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        if (response.headers['content-disposition'] === undefined) {
          this.$message({
            type: 'error',
            message: '无所选类型系统!',
          });
          return;
        }
        let name = response.headers['content-disposition'].split('=')[1];
        link.download = decodeURI(name);
        document.body.appendChild(link);
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', false, false);
        link.dispatchEvent(evt);
        document.body.removeChild(link);
        this.code_list1 = [];
        this.outFormVisible = false;
        this.$message({
          type: 'success',
          message: '导出成功!',
        });
        this.clearData();
      });
      this.outFormVisible = false;
      this.clearData();
    },
    show_BuildingSign_clear() {
      this.value1 = false;
      this.SignFlag();
      this.building_out_value = false;
      this.change_building_out_value();
      this.new_building_prompt = '';
      this.newBuildingName = '';
      this.new_entity_code = '';
      this.new_project_code = '';
      this.building_prompt = '';
      this.buildingName = '';
      this.entity_code = '';
      this.project_code = '';
      this.regionName = '';
      this.building_code = '';
      this.show_BuildingSign = false;
    },
    //新建实体编码
    newCreateProjectBuildingSign() {
      if (this.newBuildingName.split(' ').join('').length !== 0) {
        this.$axios({
          method: 'post',
          url: this.IBMS_API + 'NewEnergy/building/CreateProjectBuildingSign',
          data: {
            version: 'V1.1',
            timestamp: '0',
            data: {
              /*'pr_name':this.pr_name,
           'city_name':this.city_name,
           'dis_name':this.dis_name,*/
              outside_id: this.new_building_code,
              name: this.newBuildingName,
              project_id: this.project_id,
              platform_id: this.platformid,
              flag: 0,
            },
          },
        }).then((response) => {
          if (response.data.result === 200) {
            this.new_entity_code = response.data.content.entity_code;
            this.new_project_code = response.data.content.pro_entity_code;
            this.$message({
              type: 'success',
              message: '新建成功!',
            });
            this.queryBuildingNameList();
          }
        });
      } else {
        this.new_building_prompt = '建筑名称不能为空';
        this.new_entity_code = '';
        this.new_project_code = '';
        this.regionName = '';
      }
    },
    //查看实体编码
    createProjectBuildingSign() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'NewEnergy/building/CreateProjectBuildingSign',
        data: {
          version: 'V1.1',
          timestamp: '0',
          data: {
            outside_id: this.building_code,
            name: this.buildingName,
            project_id: this.project_id,
            platform_id: this.platformid,
            flag: this.flag_type,
          },
        },
      }).then((response) => {
        if (response.data.result === 200) {
          if (this.flag_type === 0) {
            if (this.buildingName === '') {
              this.building_prompt = '建筑名称不能为空';
              this.entity_code = '';
              this.project_code = '';
              this.regionName = '';
              this.building_code = '';
            } else {
              this.entity_code = response.data.content.entity_code;
              this.project_code = response.data.content.pro_entity_code;
              this.building_code = response.data.content.outside_id;
            }
          } else if (this.flag_type === 1) {
            this.project_code = response.data.content.pro_entity_code;
          }
        }
      });
    },
    //删除建筑实体编码
    deleteBuildingCode() {
      this.$axios({
        method: 'post',
        url:
          this.IBMS_API + 'IBMS/global/CONFIG/ConfigIndex/DeleteBuildingCode',
        data: {
          version: 'V1.1',
          timestamp: '0',
          data: {
            building_name: this.buildingName,
            project_id: this.project_id,
            platform_id: this.platformid,
          },
        },
      }).then((response) => {
        if (response.data.result === 200) {
          if (this.buildingName === '') {
            this.building_prompt = '建筑名称不能为空';
          } else {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.queryBuildingNameList();
            this.show_BuildingSign_clear();
          }
        } else if (response.data.result === 9999) {
          this.$message({
            type: 'error',
            message: '删除失败!',
          });
        }
      });
    },
    //查看建筑名称
    queryBuildingNameList() {
      this.$axios({
        method: 'post',
        url:
          this.IBMS_API +
          'IBMS/global/CONFIG/ConfigIndex/QueryBuildingNameList',
        data: {
          version: 'V1.1',
          timestamp: '0',
          data: {
            project_id: this.project_id,
            platform_id: this.platformid,
          },
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.buliding_name_list = response.data.content.name_list;
        }
      });
    },
    //导出能耗类型
    export_consumption_mb() {
      if (this.building_id === '') {
        this.$message({
          type: 'error',
          message: '请选择建筑!',
        });
      } else {
        this.fullscreenLoading = true;
        if (this.project_id !== '') {
          this.$axios({
            method: 'post',
            url: this.IBMS_API + 'IBMS/export_and_import/energy_model/export',
            data: {
              version: '1.1',
              data: {
                building_id: this.building_id,
              },
            },
            responseType: 'blob',
          }).then((response) => {
            if (!response) {
              return;
            }
            this.fullscreenLoading = false;
            let blob = new Blob([response.data], { type: '' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            let name = response.headers['content-disposition'].split('=')[1];
            link.download = decodeURI(name);
            document.body.appendChild(link);
            var evt = document.createEvent('MouseEvents');
            evt.initEvent('click', false, false);
            link.dispatchEvent(evt);
            document.body.removeChild(link);
            this.outFormVisible = false;
            this.$message({
              type: 'success',
              message: '导出成功!',
            });
            this.clearData();
          });
        } else {
          this.$message({
            type: 'error',
            message: '缺失项目ID!',
          });
        }
      }
    },
    //导出设备
    export_equipment_mb() {
      if (this.radio === 1 && this.building_id === '') {
        this.$message({
          type: 'error',
          message: '请选择建筑!',
        });
      } else {
        if (this.object_code !== '') {
          var id = this.project_id;
          if (this.radio === 0) {
            this.building_id = '';
          } else {
            id = null;
          }
          this.fullscreenLoading = true;
          this.$axios({
            method: 'post',
            url: this.IBMS_API + 'IBMS/export_and_import/equipment/export',
            data: {
              version: '1.1',
              data: {
                c_code: this.object_code,
                project_id: id,
                building_id: this.building_id,
              },
            },
            responseType: 'arraybuffer',
          }).then((response) => {
            if (!response) {
              return;
            }
            this.fullscreenLoading = false;
            let blob = new Blob([response.data], { type: '' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            let name = response.headers['content-disposition'].split('=')[1];
            link.download = decodeURI(name);
            document.body.appendChild(link);
            var evt = document.createEvent('MouseEvents');
            evt.initEvent('click', false, false);
            link.dispatchEvent(evt);
            document.body.removeChild(link);
            this.equipTypeName = '';
            this.category_code = '';
            this.outFormVisible = false;
            this.$message({
              type: 'success',
              message: '导出成功!',
            });
            this.clearData();
            // }
          });
        } else {
          this.$message({
            type: 'error',
            message: '请选择设备类型!',
          });
        }
      }
      this.outFormVisible = false;
      this.clearData();
    },
    //导出建筑
    export_build_mb() {
      if (this.ex_type !== '' && this.project_id !== '') {
        if (this.radio === 1 && this.building_ids.length === 0) {
          this.$message({
            type: 'error',
            message: '请填选择建筑!',
          });
        } else {
          var id = this.project_id;
          if (this.radio === 0) {
            this.building_ids = [];
          } else {
            id = null;
          }
          this.fullscreenLoading = true;
          this.$axios({
            method: 'post',
            url: this.IBMS_API + 'IBMS/export_and_import/building/export',
            data: {
              version: '1.1',
              data: {
                project_id: id,
                building_ids: this.building_ids,
                name: this.ex_type,
              },
            },
            responseType: 'blob',
          }).then((response) => {
            if (!response) {
              return;
            }
            if (this.message_number === 0) {
              this.$message({
                type: 'error',
                message: '没有建筑可以导出!',
              });
            }
            this.fullscreenLoading = false;
            let blob = new Blob([response.data], { type: '' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            let name = response.headers['content-disposition'].split('=')[1];
            link.download = decodeURI(name);
            document.body.appendChild(link);
            var evt = document.createEvent('MouseEvents');
            evt.initEvent('click', false, false);
            link.dispatchEvent(evt);
            document.body.removeChild(link);
            this.outFormVisible = false;
            this.$message({
              type: 'success',
              message: '导出成功!',
            });
            this.clearData();
            this.ex_type = '建筑';
            this.building_ids = [];
            this.checkAll = [];
          });
        }
      } else {
        this.$message({
          type: 'error',
          message: '请填写完整!',
        });
      }
    },
    //导出支路
    export_branch() {
      if (this.building_id !== '') {
        this.fullscreenLoading = true;
        this.$axios({
          method: 'post',
          url: this.IBMS_API + 'IBMS/export_and_import/branch/export',
          data: {
            version: '1.1',
            data: {
              building_id: this.building_id,
              object_code: '48',
            },
          },
          responseType: 'blob',
        }).then((response) => {
          if (!response) {
            return;
          }
          if (this.message_number === 0) {
            this.$message({
              type: 'error',
              message: '没有建筑可以导出!',
            });
          }
          this.fullscreenLoading = false;
          let blob = new Blob([response.data], { type: '' });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          let name = response.headers['content-disposition'].split('=')[1];
          link.download = decodeURI(name);
          document.body.appendChild(link);
          var evt = document.createEvent('MouseEvents');
          evt.initEvent('click', false, false);
          link.dispatchEvent(evt);
          document.body.removeChild(link);
          this.outFormVisible = false;
          this.$message({
            type: 'success',
            message: '导出成功!',
          });
          this.clearData();
          this.ex_type = '支路';
          this.building_id = '';
        });
      } else {
        this.$message({
          type: 'error',
          message: '请填写完整!',
        });
      }
    },
    //下载能耗类型模板
    down_consumption_mb() {
      this.fullscreenLoading = true;
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/export_and_import/energy_model/gen_template',
        data: {
          version: '1.1',
          data: {},
        },
        responseType: 'blob',
      }).then((response) => {
        if (!response) {
          return;
        }
        this.fullscreenLoading = false;
        let blob = new Blob([response.data], { type: '' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        let name = response.headers['content-disposition'].split('=')[1];
        link.download = decodeURI(name);
        document.body.appendChild(link);
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', false, false);
        link.dispatchEvent(evt);
        document.body.removeChild(link);
        this.outFormVisible = false;
        this.$message({
          type: 'success',
          message: '下载成功!',
        });
        this.clearData();
      });
    },
    //下载系统魔板
    down_system_mb() {
      if (this.systemId_list.length !== 0) {
        this.fullscreenLoading = true;
        this.$axios({
          method: 'post',
          url: this.IBMS_API + 'IBMS/export_and_import/system/gen_template',
          data: {
            version: '1.1',
            data: {
              code_list: this.systemId_list,
            },
          },
          responseType: 'blob',
        }).then((response) => {
          if (!response) {
            return;
          }
          this.fullscreenLoading = false;
          let blob = new Blob([response.data], { type: '' });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          console.log(response.headers);
          let name = response.headers['content-disposition'].split('=')[1];
          link.download = decodeURI(name);
          document.body.appendChild(link);
          var evt = document.createEvent('MouseEvents');
          evt.initEvent('click', false, false);
          link.dispatchEvent(evt);
          document.body.removeChild(link);
          this.outFormVisible = false;
          this.equipTypeName = '';
          this.category_code = '';
          this.$message({
            type: 'success',
            message: '下载成功!',
          });
          this.clearData();
        });
      } else {
        this.$message({
          type: 'error',
          message: '请填写完整!',
        });
      }
    },
    //下载设备模板
    down_equipment_mb() {
      if (this.object_code !== '') {
        this.fullscreenLoading = true;
        this.$axios({
          method: 'post',
          url: this.IBMS_API + 'IBMS/export_and_import/equipment/gen_template',
          data: {
            version: '1.1',
            data: {
              c_code: this.object_code,
            },
          },
          responseType: 'blob',
        }).then((response) => {
          if (!response) {
            return;
          }
          this.fullscreenLoading = false;
          let blob = new Blob([response.data], { type: '' });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          let name = response.headers['content-disposition'].split('=')[1];
          link.download = decodeURI(name);
          document.body.appendChild(link);
          var evt = document.createEvent('MouseEvents');
          evt.initEvent('click', false, false);
          link.dispatchEvent(evt);
          document.body.removeChild(link);
          this.outFormVisible = false;
          this.equipTypeName = '';
          this.category_code = '';
          this.$message({
            type: 'success',
            message: '下载成功!',
          });
          this.clearData();
        });
      } else {
        this.$message({
          type: 'error',
          message: '请填写完整!',
        });
      }
    },
    //下载建筑模板
    down_build_mb() {
      if (this.ex_type !== '') {
        this.fullscreenLoading = true;
        this.$axios({
          method: 'post',
          url: this.IBMS_API + 'IBMS/export_and_import/building/gen_template',
          data: {
            version: '1.1',
            data: {
              name: this.ex_type,
            },
          },
          responseType: 'blob',
        }).then((response) => {
          if (!response) {
            return;
          }
          this.fullscreenLoading = false;
          let blob = new Blob([response.data], { type: '' });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          let name = response.headers['content-disposition'].split('=')[1];
          link.download = decodeURI(name);
          document.body.appendChild(link);
          var evt = document.createEvent('MouseEvents');
          evt.initEvent('click', false, false);
          link.dispatchEvent(evt);
          document.body.removeChild(link);
          this.outFormVisible = false;
          this.ex_type = '建筑';
          this.$message({
            type: 'success',
            message: '下载成功!',
          });
          this.clearData();
        });
      } else {
        this.$message({
          type: 'error',
          message: '请填写完整!',
        });
      }
    },
    //上传建筑
    importFile(content) {
      this.fullscreenLoading = true;
      let postData = new FormData();
      postData.append('file', content.file);
      postData.append('project_id', this.project_id);
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/export_and_import/building/import',
        data: postData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        responseType: 'blob',
      }).then((response) => {
        let blob = new Blob([response.data], { type: '' });
        let reader = new FileReader();
        this.fullscreenLoading = false;
        reader.addEventListener('loadend', () => {
          try {
            let res = JSON.parse(reader.result);
            if (res.result === 200) {
              this.$message({
                type: 'success',
                message: '上传成功!',
              });
              this.get_building_list();
            } else {
              this.$message({
                type: 'error',
                message: '上传失败!',
              });
            }
          } catch (err) {
            //如果上传失败，下载错误文件
            let blob = new Blob([response.data], { type: '' }); //这里的blob是上面的response.data
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            let name = response.headers['content-disposition'].split('=')[1];
            link.download = decodeURI(name);
            document.body.appendChild(link);
            var evt = document.createEvent('MouseEvents');
            evt.initEvent('click', false, false);
            link.dispatchEvent(evt);
            document.body.removeChild(link);
          }
        });
        reader.readAsText(blob, 'utf-8');
        this.$refs.all_upload1.clearFiles();
      });
    },
    //下载异常文件
    down_error_flie(row) {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/global/CONFIG/ConfigIndex/DownloadErrorFile',
        data: {
          version: '1.1',
          data: {
            upload_id: row.id,
          },
        },
        responseType: 'blob',
      }).then((response) => {
        let blob = new Blob([response.data], { type: '' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        let name = response.headers['content-disposition'].split('=')[1];
        link.download = decodeURI(name);
        document.body.appendChild(link);
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', false, false);
        link.dispatchEvent(evt);
        document.body.removeChild(link);
      });
    },
    // 查询上传状态
    query_upload_state() {
      this.upload_dialog = true;
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/global/CONFIG/ConfigIndex/QueryUpload',
        data: {
          version: 'V1.1',
          timestamp: '',
          data: {
            project_id: this.project_id,
            platform_id: this.platformid,
          },
        },
      }).then((response) => {
        console.log(response.data);
        this.upload_state_list = response.data.content.upload_state_list;
      });
    },
    //上传支路
    import_branch_File(content) {
      this.fullscreenLoading = true;
      let postData = new FormData();
      postData.append('file', content.file);
      postData.append('project_id', this.project_id);
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/export_and_import/branch/import',
        data: postData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        responseType: 'blob',
      }).then((response) => {
        let blob = new Blob([response.data], { type: '' });
        let reader = new FileReader();
        this.fullscreenLoading = false;
        reader.addEventListener('loadend', () => {
          try {
            let res = JSON.parse(reader.result);
            if (res.result === 200) {
              this.$message({
                type: 'success',
                message: '上传成功!',
              });
              this.get_building_list();
            } else {
              this.$message({
                type: 'error',
                message: res.content,
              });
            }
          } catch (err) {
            //如果上传失败，下载错误文件
            let blob = new Blob([response.data], { type: '' }); //这里的blob是上面的response.data
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            let name = response.headers['content-disposition'].split('=')[1];
            link.download = decodeURI(name);
            document.body.appendChild(link);
            var evt = document.createEvent('MouseEvents');
            evt.initEvent('click', false, false);
            link.dispatchEvent(evt);
            document.body.removeChild(link);
          }
        });
        // if(response.data.result!==200){
        //   this.$message({
        //     type: 'error',
        //     message: '上传失败!'
        //   })
        // }
        reader.readAsText(blob, 'utf-8');
        this.$refs.all_upload5.clearFiles();
      });
    },
    //上传设备
    import_equipmen_File(content) {
      this.fullscreenLoading = true;
      let postData = new FormData();
      postData.append('file', content.file);
      postData.append('project_id', this.project_id);
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/export_and_import/equipment/import',
        data: postData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        responseType: 'blob',
      }).then((response) => {
        let blob = new Blob([response.data], { type: '' });
        let reader = new FileReader();
        this.fullscreenLoading = false;
        reader.addEventListener('loadend', () => {
          try {
            let res = JSON.parse(reader.result);
            if (res.result === 200) {
              this.$message({
                type: 'success',
                message: '上传成功!',
              });
              this.get_building_list();
            } else {
              this.$message({
                type: 'error',
                message: res.content,
              });
            }
          } catch (err) {
            //如果上传失败，下载错误文件
            let blob = new Blob([response.data], { type: '' }); //这里的blob是上面的response.data
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            let name = response.headers['content-disposition'].split('=')[1];
            link.download = decodeURI(name);
            document.body.appendChild(link);
            var evt = document.createEvent('MouseEvents');
            evt.initEvent('click', false, false);
            link.dispatchEvent(evt);
            document.body.removeChild(link);
          }
        });
        // if(response.data.result!==200){
        //   this.$message({
        //     type: 'error',
        //     message: '上传失败!'
        //   })
        // }
        reader.readAsText(blob, 'utf-8');
        this.$refs.all_upload2.clearFiles();
      });
    },
    //上传系统
    import_system_File(content) {
      this.fullscreenLoading = true;
      let postData = new FormData();
      postData.append('file', content.file);
      postData.append('project_id', this.project_id);
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/export_and_import/system/import',
        data: postData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        responseType: 'blob',
      }).then((response) => {
        let blob = new Blob([response.data], { type: '' });
        let reader = new FileReader();
        this.fullscreenLoading = false;
        reader.addEventListener('loadend', () => {
          try {
            let res = JSON.parse(reader.result);
            console.log(res, '223');
            if (res.result === 200) {
              this.$message({
                type: 'success',
                message: '上传成功!',
              });
              this.get_building_list();
            } else {
              this.$message({
                type: 'error',
                message: res.content,
              });
            }
          } catch (err) {
            console.log('789');
            //如果上传失败，下载错误文件
            let blob = new Blob([response.data], { type: '' }); //这里的blob是上面的response.data
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            let name = response.headers['content-disposition'].split('=')[1];
            link.download = decodeURI(name);
            document.body.appendChild(link);
            var evt = document.createEvent('MouseEvents');
            evt.initEvent('click', false, false);
            link.dispatchEvent(evt);
            document.body.removeChild(link);
          }
        });
        // if(response.data.result!==200){
        //   this.$message({
        //     type: 'error',
        //     message: '上传失败!'
        //   })
        // }
        reader.readAsText(blob, 'utf-8');
        this.fullscreenLoading = false;
        this.$refs.all_upload4.clearFiles();
      });
    },
    //上传能耗模型
    import_consumption_File(content) {
      this.fullscreenLoading = true;
      this.upload_id = '';
      let postData = new FormData();
      postData.append('file', content.file);
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/export_and_import/energy_model/import',
        data: postData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        responseType: 'blob',
      }).then((response) => {
        let blob = new Blob([response.data], { type: '' });
        let reader = new FileReader();
        this.fullscreenLoading = false;
        console.log('222');
        reader.addEventListener('loadend', () => {
          console.log(reader.result, '111');
          try {
            let res = JSON.parse(reader.result);
            if (res.result === 200) {
              this.$message({
                type: 'success',
                message: '上传成功!',
              });
              this.get_building_list();
            } else {
              this.$message({
                type: 'error',
                message: res.content,
              });
            }
          } catch (err) {
            console.log(reader.result, '333');
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            let name = response.headers['content-disposition'].split('=')[1];
            link.download = decodeURI(name);
            document.body.appendChild(link);
            var evt = document.createEvent('MouseEvents');
            evt.initEvent('click', false, false);
            link.dispatchEvent(evt);
            document.body.removeChild(link);
          }
        });
        // if(response.data.result!==200){
        //   this.$message({
        //     type: 'error',
        //     message: '上传失败!'
        //   })
        // }
        reader.readAsText(blob, 'utf-8');
        this.fullscreenLoading = false;
        this.$refs.all_upload3.clearFiles();
      });
    },
    //树节点点击事件：选择设备类型
    handleNodeClick(data) {
      var node = this.$refs.typetree.getNode(data);
      console.log(data, 'vyuj');
      if (node.isLeaf === true) {
        this.equipTypeName = data.name;
        this.object_code = data.code;
        this.$refs.Dropdown2.hide();
      }
    },

    //递归函数
    r_obj(data) {
      let temp = [];
      for (let i in data) {
        let label = data[i].name;
        let id = data[i].id;
        let sonList = [];
        if (data.sonList !== []) {
          sonList = this.r_obj(data[i].sonList);
        } else {
          sonList = [];
        }
        temp.push({ label: label, id: id, children: sonList });
      }
      return temp;
    },
    is_todo(row) {
      this.$confirm('此操作将永久删除该建筑, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.toDelete(row);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    //删除建筑
    toDelete(row) {
      this.$axios({
        url: this.IBMS_API + 'IBMS/Public/DeprecatOrDeleteObject',
        method: 'post',
        data: {
          version: '1.1',
          data: {
            id_list: [row.id],
            flag: 'delete',
          },
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            message: '删除成功',
            type: 'success',
          });
          this.get_building_list();
        }
      });
    },
    //跳转到编辑
    toEdit(i, row) {
      if (i == 1) {
        this.$router.push({
          path: '/IBMS/config/new_project',
          query: { type: i, building_id: row.id },
        });
      } else if (i == 0) {
        this.$router.push({
          path: '/IBMS/config/new_project',
          query: { type: i, building_id: '' },
        });
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.get_building_list();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.get_building_list();
    },
    closeDialog(data) {
      this.showFlag = data;
      this.fresh = data;
    },
    openDialog() {
      this.showFlag = true;
      this.fresh = true;
    },
    get_func_list() {
      this.$axios({
        url: this.IBMS_API + 'IBMS/global/CONFIG/generic/QueryFuncList',
        method: 'post',
        data: {
          version: '1.1',
          data: {
            platform_id: this.platformid,
          },
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.options = response.data.content;
        }
      });
    },
    get_new_auth_attr() {
      this.dialogVisible = true;
      this.$axios({
        url: this.IBMS_API + 'IBMS/global/CONFIG/ConfigIndex/GetAuthAttr',
        method: 'post',
        data: {
          version: '1.1',
          data: {
            platform_id: this.platformid,
          },
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.auth_attr_list = response.data.content;
          this.$store.commit('set_new_auth_data', this.auth_attr_list);
        }
      });
    },
    add_auth() {
      let check = this.$check_data([this.$store.state.new_auth_data]);
      if (!check) return;
      this.$axios({
        url: this.IBMS_API + 'IBMS/global/CONFIG/ConfigIndex/SaveNewAuth',
        method: 'post',
        data: {
          version: '1.1',
          data: {
            attr_list: this.$store.state.new_auth_data,
            func_id: this.value,
            platform_id: this.platformid,
          },
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.dialogVisible = false;
          this.auth_attr_list = [];
          this.options = [];
          this.value = null;
          this.$message({
            message: '创建成功',
            type: 'success',
          });
        }
      });
    },
    null_building_list() {
      if (this.building_list != []) {
        this.building_name = this.building_list[0].building_name;
        this.building_id = this.building_list[0].building_id;
      }
    },
    goBack() {
      this.$store.state.project_id = '';
      // this.$router.push({path: '/IBMS/platform/createNewProject'});
      this.$router.back();
    },
    handleCheckAllChange(val) {
      this.buildingName_type = [];
      this.building_names = val ? this.building_list : [];
      this.isIndeterminate = false;
      if (val === true) {
        var id_list = [];
        for (let i in this.building_list) {
          id_list.push(this.building_list[i].building_id);
          this.buildingName_type.push(this.building_list[i].building_name);
        }
        this.building_ids = id_list;
      } else {
        this.building_ids = [];
      }
    },
    handleCheckedCitiesChange(value) {
      this.buildingName_type = [];
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.building_list.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.building_list.length;
      var id_list = [];
      for (let i in value) {
        id_list.push(value[i].id);
        this.buildingName_type.push(value[i].name);
      }
      this.building_ids = id_list;
      this.building_names = value;
    },
  },
};
</script>

<style scoped>
/deep/ .upload-demo {
  width: 300px;
  display: inline;
  margin: 0 0 0 10px;
}

#touch {
  moz-user-select: -moz-none;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.rt-input /deep/ .el-input__inner {
  color: #409eff !important;
  cursor: pointer;
}
</style>
